import { NgModule } from '@angular/core';
import { KwotaPipe } from './kwota.pipe';

@NgModule({
  declarations: [KwotaPipe],
  exports: [KwotaPipe]
})
export class SharedPipesModule { }
